import './PromotionCodeInput.scss';

import {
  type ChangeEvent,
  type FocusEvent,
  type KeyboardEvent,
  PureComponent,
} from 'react';

import * as Core from 'components/core';
import { Translation } from 'react-i18next';

interface Props {
  value: string;
  disabled: boolean;
  errorMessage?: string;
  onChange(event: ChangeEvent): void;
  onBlur(event: FocusEvent): void;
  onApply(): void;
}

export class PromotionCodeInput extends PureComponent<Props> {
  static displayName = 'Checkout.PromotionCodeInput';

  handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.which === 13) {
      event.preventDefault();

      this.props.onApply();

      event.currentTarget.blur();
    }
  };

  render() {
    const { value, disabled, errorMessage, onChange, onBlur, onApply } =
      this.props;

    return (
      <Translation ns={['translation', 'checkout']}>
        {(t) => (
          <Core.FormGroup
            label={t('payment.promotionCode', { ns: 'checkout' })}
            errorMessage={errorMessage}
          >
            <div className="PromotionCodeInput">
              <Core.Input
                name="promotionCode"
                disabled={disabled}
                testID="promotion-code-field"
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                onKeyPress={this.handleKeyPress}
              />

              <Core.Button onClick={onApply}>
                {t('payment.applyPromotionCode', { ns: 'checkout' })}
              </Core.Button>
            </div>
          </Core.FormGroup>
        )}
      </Translation>
    );
  }
}

export default PromotionCodeInput;
